import { IdxFeed } from "gql/generated.graphql";
import { useState } from "react";

// Types
type DeleteIdxFeedModalProps = {
  idxFeed?: IdxFeed | null;
  onCancel?: () => void;
  onConfirm?: () => Promise<void>;
};

// Main Component
export function DeleteIdxFeedModal(props: DeleteIdxFeedModalProps) {
  const [loading, setLoading] = useState<boolean>(false);

  // Function to handle confirm
  async function confirm() {
    setLoading(true);
    if (props.onConfirm) await props.onConfirm();
    if (props.onCancel) props.onCancel();
    setLoading(false);
  }

  if (!props.idxFeed) return <></>;

  // HTML Component
  return (
    <div className="fixed w-screen h-screen bg-black/30 top-0 left-0 z-10 flex items-center justify-center">
      <div className="bg-white shadow-2xl rounded-lg p-6 flex flex-col w-full max-w-md gap-6 relative">
        <header className="flex justify-center">
          <h1 className="font-bold">Confirm Deletion?</h1>
        </header>
        <main className="flex flex-col gap-1">
          <p>Do you really want to delete the {props.idxFeed.name} feed?</p>
          <p>Please note that this action cannot be undone.</p>
        </main>
        <footer className="flex gap-4 justify-end">
          <button
            disabled={loading}
            type="button"
            className="h-10 px-4 rounded-lg bg-red-600 text-white hover:brightness-110 disabled:opacity-30"
            onClick={confirm}
          >
            Delete
          </button>
          <button
            type="reset"
            onClick={props.onCancel}
            className="h-10 border border-slate-300 px-4 rounded-lg hover:bg-black/5"
          >
            Cancel
          </button>
        </footer>
      </div>
    </div>
  );
}
